import { render, staticRenderFns } from "./SettlementRentView.vue?vue&type=template&id=16312c4c"
import script from "./SettlementRentView.vue?vue&type=script&lang=js"
export * from "./SettlementRentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports